export { getLocationIcons } from './get-location-icons';
